const colors = {
  primary: '#1D8960',
  secondary: '#00C67F',

  secondaryText: '#333333',
  landingSecondaryText: '#20435D',
  tableBody: '#424242',
  white: '#FFFFFF',
  gray99: '#fcfcfc',
  greenLight: '#ECFDF5',
  black: '#000000',
  blueFade: '#003F55',
  blueLight: '#006D9D',
  skyBlueLight: '#207FA9',
  skyGreenLight: '#26C9A4',
  greeenfadeLight: '#E6F4F14D',

  blueShadow: '#F3F9FD',
  green: { strong: '#00C67F', faded: '#CEFBE3' },
  yellow: { strong: '#FFCC28', faded: '#FFFED1' },
  red: { strong: '#FF3838', faded: '#FECEC3' },
  blue: { strong: '#0383C5', faded: '#AFE1F2' },
  capriBlue: { strong: '#00BDFF', faded: '#CEF6FF' },
  munsellBlue: { strong: '#008AA8', faded: '#CCFEFF' },
  OrangeBrown: { strong: '#9D7000', faded: '#FFF0CA' },
  darkViolet: { strong: '#A100DA', faded: '#EAB3FE' },
  darkSlateGray: { strong: '#2F4858', faded: '#9AB1C0' },
  darkCoral: '#CA5237',
  cardColor: '#FFFFFF',
  mustardGreen: '#757438',
  darkText: '#1F1F1F',
  normalText: '#3D3D3D',
  disableText: '#C7C7C7',
  disableButtonText: '#B3B3B3',
  border: '#8A8A8A',
  disable: '#E0E0E0',
  defaultButton: '#EBEBEB',
  lightBackground: '#F0F0F0',
  lighterBackground: '#F5F5F5',
  tabText: '#616161',
  popoverBg: '#FAFAFA',
  client: { strong: '#00BDFF', faded: '#CEF6FF' },
  technician: { strong: '#1D8A5A', faded: '#CEFBE3' },
  printer: { strong: '#008AA8', faded: '#CCFEFF' },
  admin: { strong: '#2F4858', faded: '#DAF0FF' },
  draftman: { strong: '#757438', faded: '#d9d8c5' },
  fireTeam: { strong: '#CA5237', faded: '#e8c6be' },
  professional: { strong: '#2F4858', faded: '#DAF0FF' },
  transparent: 'transparent',
  scrollThumb: '#717171',
  CLIENT: { strong: '#00BDFF', faded: '#CEF6FF' },
  TECHNICIAN: { strong: '#1D8A5A', faded: '#CEFBE3' },
  PRINTER: { strong: '#008AA8', faded: '#CCFEFF' },
  ADMIN: { strong: '#2F4858', faded: '#DAF0FF' },
};
export default colors;

export type ColorsType = typeof colors;
